<template>
  <footer class="footer" v-if="!$route.meta.hideFooter">
    <div class="container">
      <div class="footer-content">
        <div class="footer-section">
          <h3>安裕和國際企業社</h3>
          <p>安心醫療，共裕祥和。</p>
        </div>

        <div class="footer-section">
          <h3>聯絡我們</h3>
          <p>
            <i class="fas fa-phone"></i> {{ contactInfo.phone || "載入中..." }}
          </p>
          <p><i class="fas fa-envelope"></i> annyoohoh@gmail.com</p>
        </div>

        <div class="footer-section">
          <h3>營業時間</h3>
          <p>週一至週五: 9:00 - 18:00</p>
        </div>

        <div class="footer-section">
          <h3>社群媒體</h3>
          <div class="social-links">
            <a
              href="https://www.facebook.com/share/19kzCLu2aW/"
              target="_blank"
            >
              <i class="fab fa-facebook-square"></i>
            </a>
            <a href="https://lin.ee/vFz8qQO" target="_blank">
              <i class="fab fa-line"></i>
            </a>
            <a
              href="https://www.instagram.com/annyoohoh?igsh=MWEzMjU0M3QyMjN6Nw=="
              target="_blank"
            >
              <i class="fa-brands fa-instagram fa-lg"></i>
            </a>
          </div>
        </div>
      </div>

      <!-- 🔥 新版版權宣告 footer-bottom -->
      <div class="footer-bottom">
        <p>© {{ new Date().getFullYear() }} 安裕和國際企業社 版權所有</p>
        <p>Design by 彩虹小馬工作室</p>
      </div>
    </div>
  </footer>
</template>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.container {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 clamp(1rem, 3vw, 2rem);
}

.footer {
  background: #3b3b7e;
  color: white;
  padding: clamp(2rem, 4vh, 3rem) 0 clamp(1rem, 2vh, 1.5rem);
  margin-top: auto;
}

.footer-content {
  display: grid;
  grid-template-columns: 1fr;
  gap: clamp(1.5rem, 3vh, 2rem);
  margin-bottom: clamp(1.5rem, 3vh, 2rem);
  text-align: center;
}

@media (min-width: 768px) {
  .footer-content {
    grid-template-columns: repeat(2, 1fr);
    gap: clamp(2rem, 4vh, 3rem);
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
  }
}

@media (min-width: 1024px) {
  .footer-content {
    grid-template-columns: repeat(4, 1fr);
    gap: clamp(2rem, 5vw, 4rem);
    max-width: 1200px;
    text-align: left;
  }
}

.footer-section {
  display: flex;
  flex-direction: column;
  align-items: center;
}

@media (min-width: 1024px) {
  .footer-section {
    align-items: flex-start;
  }
}

.footer-section h3 {
  font-size: clamp(1.15rem, 2.2vw, 1.3rem);
  margin-bottom: clamp(0.75rem, 1.5vh, 1rem);
  font-weight: 600;
  word-wrap: break-word;
}

.footer-section p {
  font-size: clamp(0.95rem, 1.8vw, 1.05rem);
  line-height: 1.7;
  margin-bottom: clamp(0.5rem, 1vh, 0.6rem);
  word-wrap: break-word;
}

.footer-section i {
  margin-right: clamp(0.5rem, 1vw, 0.6rem);
  width: clamp(18px, 3vw, 20px);
  display: inline-block;
  text-align: center;
}

.social-links {
  display: flex;
  gap: clamp(1rem, 2vw, 1.5rem);
  flex-wrap: wrap;
  justify-content: center;
}

.social-links a {
  text-decoration: none; /* 移除底線 */
}

@media (min-width: 1024px) {
  .social-links {
    justify-content: flex-start;
  }
}

.social-links a {
  color: white;
  font-size: clamp(1.8rem, 3vw, 2rem);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.social-links a:hover {
  transform: translateY(-3px);
  opacity: 0.8;
}

/* ------------------------- */
/* 🔥 新 footer-bottom 樣式整合 */
/* ------------------------- */
.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.3);
  padding: clamp(18px, 3.5vh, 24px) 0 0;
  margin-top: clamp(28px, 5vh, 36px);
  font-size: clamp(0.75rem, 2vw, 0.875rem);
  text-align: center;
  opacity: 0.9;
}

.footer-bottom p {
  margin: clamp(4px, 0.8vh, 6px) 0;
  line-height: 1.6;
}

/* 平板版 */
@media (min-width: 768px) {
  .footer-bottom {
    max-width: 1200px;
    margin: clamp(36px, 6vh, 44px) auto 0;
    padding: clamp(18px, 3.5vh, 24px) clamp(32px, 5vw, 40px) 0;
  }

  .footer-bottom p {
    display: inline;
    margin: 0;
  }

  .footer-bottom p + p::before {
    content: " | ";
    margin: 0 clamp(8px, 1.2vw, 10px);
  }
}

/* 桌機版 */
@media (min-width: 1024px) {
  .footer-bottom {
    padding: clamp(18px, 3.5vh, 24px) clamp(48px, 8vw, 60px) 0;
  }
}
</style>

<script>
import api from "@/assets/js/utils/api";

export default {
  name: "AppFooter",
  data() {
    return {
      contactInfo: {
        phone: "",
        address: "",
      },
    };
  },
  mounted() {
    this.fetchContactInfo();
  },
  methods: {
    async fetchContactInfo() {
      try {
        const response = await api.get("/dashboard/contact");
        if (response.data.success) {
          this.contactInfo.phone = response.data.data.Phone || "";
          this.contactInfo.address = response.data.data.Address || "";
        }
      } catch (error) {
        console.error("獲取聯絡資訊失敗:", error);
        // 如果 API 失敗，使用預設值
        this.contactInfo.phone = "(07) 803-3324";
      }
    },
  },
};
</script>
